import { useTranslate } from '@growtherapy/i18n';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '@growtherapy/sprout-ui';

type LeaveSessionConfirmationModalProps = {
  isOpen: boolean;
  onStay: () => void;
  onLeave: () => void;
};

export function LeaveSessionConfirmationModal({ isOpen, onStay, onLeave }: LeaveSessionConfirmationModalProps) {
  const t = useTranslate();

  return (
    <Modal isOpen={isOpen} onClose={onStay} className='rebrand:rounded-none sm:!top-1/2 sm:!-translate-y-1/2'>
      <ModalHeader>{t('telehealth-core:navigationGuard.leaveSessionTitle')}</ModalHeader>
      <ModalBody>{t('telehealth-core:navigationGuard.leaveSessionBody')}</ModalBody>
      <ModalFooter
        actions={[
          {
            key: 'stay-in-session',
            use: 'secondary',
            onClick: onStay,
            actionContent: t('telehealth-core:navigationGuard.stayInSession'),
          },
          {
            key: 'leave-session',
            use: 'primary',
            onClick: onLeave,
            actionContent: t('telehealth-core:navigationGuard.leaveSession'),
          },
        ]}
      />
    </Modal>
  );
}
